import { Masonry } from '@leagueplatform/masonry';
import { ANNUAL_AUTHORIZATIONS_ROOT_NODE_ID } from 'common/constants';
import { MasonryPageContainer } from 'pages/masonry/masonry-container.page';

export const AnnualAuthorizationsPage = () => (
  <MasonryPageContainer>
    <Masonry rootNodeId={ANNUAL_AUTHORIZATIONS_ROOT_NODE_ID} />
  </MasonryPageContainer>
);
